"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var NavigationContainer = (function (_super) {
    __extends(NavigationContainer, _super);
    function NavigationContainer() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.goToNavigationStep = function (navigationStepIndex) {
            var currentStep = _this.navigationSteps[_this.currentNavigationStepIndex];
            var destinationStep = _this.navigationSteps[navigationStepIndex];
            if (currentStep && destinationStep) {
                _this.props.moveStep(destinationStep.originalIndex - currentStep.originalIndex);
            }
        };
        return _this;
    }
    Object.defineProperty(NavigationContainer.prototype, "navigationSteps", {
        get: function () {
            return this.props.steps
                .map(function (step, originalIndex) { return ({ step: step, originalIndex: originalIndex }); })
                .filter(function (_a) {
                var step = _a.step;
                return !step.excludeNavigation;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationContainer.prototype, "currentNavigationStepIndex", {
        get: function () {
            var _this = this;
            return this.navigationSteps.findIndex(function (_a) {
                var step = _a.step;
                return step.id === _this.props.currentStep.id;
            });
        },
        enumerable: false,
        configurable: true
    });
    NavigationContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentStep = _a.currentStep, children = _a.children;
        var showNavigation = !currentStep.excludeNavigation && this.navigationSteps.length > 0;
        return (react_1.default.createElement("div", { className: "create-page-flow__navigation-container" },
            showNavigation && (react_1.default.createElement("div", { className: "create-page-flow__navigation" },
                this.currentNavigationStepIndex > 0 && (react_1.default.createElement(kaleidoscope_1.Button, { className: "create-page-flow__back-link", onClick: function () { return _this.goToNavigationStep(_this.currentNavigationStepIndex - 1); }, type: kaleidoscope_1.ButtonType.Tertiary },
                    react_1.default.createElement(icons_1.ChevronLeft, null),
                    " Back")),
                react_1.default.createElement(kaleidoscope_1.StepCount, { totalSteps: this.navigationSteps.length, currentStep: this.currentNavigationStepIndex, goToAPreviousStep: this.goToNavigationStep }))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("create-page-flow__main", {
                    "create-page-flow__main--with-navigation": showNavigation,
                }) }, children),
            this.props.closeButtonHandler && (react_1.default.createElement(kaleidoscope_1.Button, { className: "create-page-flow__close-button", onClick: this.props.closeButtonHandler, type: kaleidoscope_1.ButtonType.Tertiary }, "Close"))));
    };
    return NavigationContainer;
}(react_1.default.Component));
exports.default = NavigationContainer;
